<template>
  <div class="container">
    <div class="spinner-border" role="status" v-if="loading === true">
      <span class="sr-only">cargando...</span>
    </div>
    <div class="row">
      <div class="col-12 m-0 p-0">
        <table border="1" class="table">
          <tr v-for="message in messages" :key="message.id">
            <td>
              {{
                message.username
              }}
            </td>
            <td>{{ message.text }}</td>
            <td>{{ $moment(message.fecha)}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import fire from "./../fire";
import menuAdmin from "../components/MenuAdmin";
export default {
  name: "AdminChat",
  components: { menuAdmin },
  // eslint-disable-next-line vue/no-unused-components
  data() {
    return {
      messages: [],
      loading: false,
      texto: ""
    };
  },
  methods: {

    update(item) {
      let ver = null;
      console.log(item);
      if (item.pantalla == true) {
        ver = false;
      } else {
        ver = true;
      }
      fire
        .database()
        .ref("messages/" + item.id)
        .update(
          {
            pantalla: ver
          },
          function(error) {
            if (error) {
              console.log("The write failed");
            } else {
              console.log("Data saved successfully!");
            }
          }
        );
    },
    cargaMensajes() {
      let viewMessage = this;
      const itemsRef = fire
        .database()
        .ref("messages");
      this.loading = false;
      itemsRef.on("value", snapshot => {
        let data = snapshot.val();
        let messages = [];
        Object.keys(data).forEach(key => {
          messages.push({
            id: key,
            username: data[key].username,
            text: data[key].text,
            fecha: data[key].fecha,
            pantalla: data[key].pantalla
          });
        });
        viewMessage.messages = messages;
      });
    }
  },
  mounted() {
    this.cargaMensajes();
  }
};
</script>

<style lang="scss">
.table {
  border-color: #ccc;
  tr {
    &:nth-child(even) {
      background: #f4f4f4;
    }
    &:nth-child(odd) {
      background: #fff;
    }
  }
  .message {
    word-break: break-all;
  }
  .fecha {
    font-style: italic;
    color: #ccc;
  }
}
</style>
